import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { ListOffer, OffersListStatus, ProcessedListOffer } from '../types';

const offerListStateSelector = (state: RootState) => state.candidateOfferList;

export const statusSelector = createSelector(
    offerListStateSelector,
    (state) => state.status
);

const availableOffersSelector = createSelector(
    offerListStateSelector,
    (state) => state.offers
);

const processedOffersSelector = createSelector(
    offerListStateSelector,
    (state) => state.processedOffers
);

export const offersListStatusSelector = createSelector(
    availableOffersSelector,
    processedOffersSelector,
    statusSelector,
    (offers, processedOffers, loadingStatus): OffersListStatus => {
        if (loadingStatus === 'success' && !offers.length && !processedOffers.length) {
            return 'empty';
        }

        if (!offers.length && processedOffers.length) {
            return 'processedOffersOnly';
        }

        if (offers.length === 1 && !processedOffers.length) {
            return 'singleOffer';
        }

        return 'regular';
    }
);

export const candidateOffersSelector = createSelector(
    availableOffersSelector,
    processedOffersSelector,
    (offers, processedOffers): Array<ProcessedListOffer | ListOffer> => {
        return [
            ...processedOffers,
            ...offers
        ];
    }
);

export const availableOffersCountSelector = createSelector(
    availableOffersSelector,
    (offers) => offers.length
);

export const declineOfferStateSelector = createSelector(
    offerListStateSelector,
    (state) => state.declineOfferState
);

export const acceptOfferStateSelector = createSelector(
    offerListStateSelector,
    (state) => state.acceptOfferState
);

export const hasMorePagesSelector = createSelector(
    offerListStateSelector,
    (state) => state.hasMorePages
);

export const loadMoreStatusSelector = createSelector(
    offerListStateSelector,
    (state) => state.loadMoreStatus
);

export const currentPageSelector = createSelector(
    offerListStateSelector,
    (state) => state.currentPage
);

export const totalOpenJobsSelector = createSelector(
    offerListStateSelector,
    (state) => state.totalOpenJobs
);

export const newThisWeekSelector = createSelector(
    offerListStateSelector,
    (state) => state.newThisWeek
);
